<template>
    <BaseModal ref="modal"
        @cancel="cancel" @confirm="triggerSubmit"
        v-model="isModalOpen"
        :title="title"
        :confirmButton="computedConfirmButton"
        :cancelButton="computedCancelButton"
        max-width="570px"
        persistent
    >
        <LevelForm
            ref="level_form"
            v-if="!loading"
            v-model="level"
            :isFirstLevel="isFirstLevel"
            :isFormValid.sync="isFormValid"
            :formType="'EDIT'"
            @submit="confirm"
            @triggerSubmit="triggerSubmit"
            :loading="loading"
        />
        <span v-else>{{ $t('forms.wait') }}</span>
    </BaseModal>
</template>

<script>
import BaseModal from '@/components/modals/BaseModal'
import LevelForm from '@/components/forms/LevelForm'
import BaseModalMixin from '../BaseModalMixin'
import Level from '@/models/Level'
import { mapGetters } from 'vuex'

export default {
    name: 'LevelsEditModal',
    mixins: [ BaseModalMixin ],
    components: { BaseModal, LevelForm },
    props: {
        level: {
            type: Level,
            required: true,
        },
        isFirstLevel: {
            type: Boolean,
            default: false,
        },
    },
    data: vm => {
        return {
            isFormValid: false,
            title: vm.$t('views.levels.Edit.title'),
            loading: false,
        }
    },
    methods: {
        triggerSubmit() {
            this.$refs.level_form.submit()
        },
        async beforeConfirm(level) {
            // Caso os níveis sejam só locais, somente atualiza a store
            if (!this.isLevelCreated) {
                this.$store.dispatch('level/updateLevel', level)
    
                this.resolveValue = this.level
                return true
            }

            if (!this.isFormValid)
                return false

            this.loading = true

            let errType
            let response = await level.update()
                .catch(err => {                    
                    if (err.message == 'Network Error') {
                        errType = 'network_error'
                        return 
                    }

                    if (err.response.data.type) {
                        errType = err.response.data.type
                        return
                    }

                    errType = 'error'
                })

            this.loading = false
            
            if (errType) {
                const definedErrors = [
                    'network_error'
                ]
                errType = definedErrors.includes(errType) ? errType : 'error'
                await new Promise((resolve) => {
                    this.$bus.$emit('alert', this.$t(`views.levels.Edit.alerts.${errType}`), 'error', resolve)
                })
                return false
            }

            this.resolveValue = this.level
            return true
        },
    },
    computed: {
        ...mapGetters({
            isLevelCreated: 'level/isCreated',
        }),

        computedConfirmButton() {
            return {
                label: this.$t('actions.save'),
                disabled: !this.isFormValid,
                loading: this.loading,
            }
        },
        computedCancelButton() {
            return {
                disabled: this.loading,
            }
        },
    },
}
</script>